// import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import './index.css';
import { persistor, store } from './redux/store';
import * as sentry from './services/sentry';
import NiceModal from '@ebay/nice-modal-react';
import { NoInternetConnectionCheck } from 'components/no-internet-connection-check/NoInternetConnectionCheck';

// Initialize sentry
sentry.boot();

ReactDOM.render(
  <React.StrictMode>
    <NoInternetConnectionCheck />
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <NiceModal.Provider>
            <App />
          </NiceModal.Provider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
